const galleryFavvedMixin = {
    methods: {
        isFavved(key, id) {
            try {
                // @todo: add cache
                const favvedItems = localStorage.getItem(key);
                if (favvedItems === null) return false;
                return JSON.parse(favvedItems).includes(id);
            } catch(error) {
                captureException(error);
                return false;
            }
        },
        toggleFavvedHandler(key, id) {
            const favvedItems = localStorage.getItem(key);
            const items = (favvedItems === null) ? [] : JSON.parse(favvedItems);
            const idx = items.indexOf(id);
            if (idx < 0) items.push(id);
            else items.splice(idx, 1);
            localStorage.setItem(key, JSON.stringify(items));
        },
    },
};

export default galleryFavvedMixin;
